import { cn } from '@/lib/utils'
import { useFindTargetCaseEoir } from '../hooks/use-find-target-case'
import dayjs from 'dayjs'

interface ApplicantCaseDetailEoirHeaderProps {
  className?: string
}

export const ApplicantCaseEoirDetailHeader: React.FC<ApplicantCaseDetailEoirHeaderProps> = ({ className }) => {
  const { targetCase } = useFindTargetCaseEoir()
  const updatedAt = targetCase?.updatedAt

  return (
    <div className={cn(className)}>
      <h2 className={cn('mb-2', 'text-[24px] font-[600] leading-[32px]')}>History</h2>
      <div className={cn('mb-1', 'text-[14px] font-[400] leading-[24px] text-[#555]')}>
        Last sent email {updatedAt ? dayjs.utc(updatedAt).format('MMM D, YYYY') : '-'}
      </div>
    </div>
  )
}
